import React from 'react';
import './App.css';
import Header from './components/Header';
import Form from './components/Form';
import Table from './components/Table';

export default function App() {
  return (
    <main>
      <Header />
      <section>
        <Form />
        <Table />
      </section>
    </main>
  );
}
